import { api } from "api/api";
import { AxiosError } from "axios";
import { Buffer } from 'buffer';
import Acao from "model/administracao/cadastro/Acao";
import LoginValidado from "model/login/LoginValidado";
import UsuarioLogado from "model/usuario/UsuarioLogado";

class UsuarioLogadoService {

    getAcoesUsuarioLogado() {

        return new Promise<Acao[]>((resolve, reject): void => {
            api
                .get(`/usuariologado/acoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });

    }

    getUsuario(): UsuarioLogado {

        return JSON.parse(JSON.parse(Buffer.from(localStorage.getItem('token')!.split('.')[1], 'base64').toString()).iss);
    }

    usuarioTemAcao(acoes: any, acao: any): boolean {
        return acoes.some((a: any) => a.sigla === acao);
    }

    usuarioTemAlgumaAcao(acoes: any, acoesAlvo: any): boolean {
        for(let i = 0; i < acoesAlvo.length; i++) {
            if(acoes.some((a: any) => a.sigla === acoesAlvo[i])) {
                return true;
            }
        }
        return false;
    }
}

export default UsuarioLogadoService;
